import { Injectable } from '@angular/core';
import 'rxjs/add/observable/fromPromise';
import { Headers, Http, Response } from '@angular/http';
import { AuthenticationService, Logger } from 'app/core/index';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

const log = new Logger('DepositService');

interface WalletInterface {
  address: string;
  currency: string;
  memo: string;
  minAmount: number;
  maxAmount: number;
  expiresAt: number;
  fee: number;
}

export type DepositSubject = boolean | any;

@Injectable()
export class DepositService {
  public depositSubject: Subject<DepositSubject> = new BehaviorSubject(false);
  deposit$: Observable<DepositSubject> = this.depositSubject.asObservable();

  constructor(private http: Http, private auth: AuthenticationService) {
    log.debug('service constructed.');
  }

  public getWallet(currency: string) {
    const headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);
    return this.http
      .get(`/api/deposit/wallet/${currency}`, { headers })
      .pipe(map((response: Response) => response.json() as WalletInterface));
  }

  /**
   * Gets converted amount to a specified currency.
   * @param {string} currency
   * @returns {Promise<Error | Response>}
   */
  public getRates(currency: string) {
    log.info('retrieving deposit rates');
    const headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);
    return this.http.get(`/api/deposit/rates/${currency}`, { headers }).pipe(
      map((response: Response) => {
        return response.json();
      })
    );
  }

  /**
   * Mark deposit for address as finished to increase check priority.
   * @param address
   * @returns {Promise<Error | Response>}
   */
  public markDepositFinished(address: string) {
    log.info('marking deposit address as finished');
    const headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);
    return this.http.post(`/api/deposit/mark-finished`, { address }, { headers }).pipe(
      map((response: Response) => {
        return response.json();
      })
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/account/deposit.service.ts